module.exports = __webpack_public_path__ + "img/ArticleOutlined.46762f08.svg";